// Version : 1.0.0
// Author : AGALYA

const RationCardDetailsActionType = {
	/** ***************** Ration Card Details Update Start ************************/
	UPDATE_RATION_CARD_START: 'update_ration_card_start',
	UPDATE_RATION_CARD_SUCCESS: 'update_ration_card_success',
	UPDATE_RATION_CARD_FAILURE: 'update_ration_card_failure',
	UPDATE_RATION_CARD_RESPONSE_REST_START: 'update_ration_card_response_reset_start',
	UPDATE_RATION_CARD_RESPONSE_CHANGED: 'update_ration_card_response_changed',
	/** ***************** Ration Card Details Update End ************************/
};

export default RationCardDetailsActionType;
